import { render } from "./TheFooter.vue?vue&type=template&id=30711ac4&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=30711ac4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30711ac4"

export default script